type SessionError = { code?: string; status?: number; detail?: string; message?: string };

export function isSessionInvalidError(error: unknown): boolean {
  const value = error as SessionError | undefined;
  if (["auth/id-token-expired", "auth/id-token-revoked", "auth/invalid-user-token",
    "auth/user-disabled", "auth/user-token-expired"].includes(value?.code ?? "")) return true;
  if (value?.status === 401) return true;
  const detail = `${value?.detail ?? value?.message ?? ""}`.toLowerCase();
  return detail.includes("invalid or expired token") || detail.includes("authentication required");
}

/** Recover a stale ID token once; persistent rejection still invalidates the session. */
export async function fetchVerifiedProfile<T>(
  user: { getIdToken(forceRefresh?: boolean): Promise<string> },
  fetchProfile: (token: string) => Promise<T>,
): Promise<T> {
  const token = await user.getIdToken();
  try {
    return await fetchProfile(token);
  } catch (error) {
    if ((error as SessionError)?.status !== 401) throw error;
    return await fetchProfile(await user.getIdToken(true));
  }
}
